import { Skeleton } from '~/components/component-library/Skeleton'

export const TransactionDialogLoadingContent = () => {
  return (
    <div className="space-y-8">
      <div className="space-y-5">
        <div className="flex justify-center">
          <Skeleton size="lg" length={4} />
        </div>
        <div className="flex flex-col items-center space-y-2">
          <Skeleton size="sm" length={16} />
          <Skeleton size="sm" length={10} />
        </div>
      </div>
      <div className="relative rounded-xl bg-gray-50 px-8 py-6 dark:bg-gray-950">
        <div className="space-y-4 pl-4">
          <Skeleton size="md" length={14} />
          <Skeleton size="md" length={14} />
          <Skeleton size="md" length={14} />
        </div>
      </div>
      <div className="divide-y divide-gray-200 dark:divide-gray-800">
        <div className="flex flex-col space-y-1 py-2">
          <div className="flex justify-between">
            <Skeleton size="sm" length={4} />
            <Skeleton size="sm" length={4} />
          </div>
          <div className="flex justify-between">
            <Skeleton size="sm" length={4} />
            <Skeleton size="sm" length={4} />
          </div>
        </div>
        <div className="flex flex-col space-y-1 py-2">
          <div className="flex justify-between">
            <Skeleton size="sm" length={4} />
            <Skeleton size="sm" length={4} />
          </div>
        </div>
        <div className="flex flex-col space-y-1 py-2">
          <div className="flex justify-between">
            <Skeleton size="sm" length={4} />
            <Skeleton size="sm" length={4} />
          </div>
          <div className="flex justify-between">
            <Skeleton size="sm" length={4} />
            <Skeleton size="sm" length={4} />
          </div>
        </div>
      </div>
    </div>
  )
}
